@if (languages().length > 1) {
  <ptl-button
    type="smoke"
    [size]="size()"
    [matMenuTriggerFor]="languageMenu"
    [icon]="LucideLanguages"
    [ariaLabel]="'translations.global.ariaLabels.icons.language' | transloco"
  ></ptl-button>

  <mat-menu #languageMenu="matMenu">
    @for (language of languages(); track language.code) {
      <button
        mat-menu-item
        class="language-menu-item"
        [class.is_active]="language.code === selectedCode()"
        [attr.aria-label]="'translations.global.ariaLabels.icons.changeLanguageTo' | transloco: { lang: language.name }"
        (click)="languageSelected.emit(language.code)"
      >
        {{ language.code.toUpperCase() }}
      </button>
    }
  </mat-menu>
}
